// extracted by mini-css-extract-plugin
export var collapsedSummary = "_ri-0";